// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_96-0";